module.exports = __webpack_public_path__ + "static/media/02-1-galeria-04-messika-mobile@2x.a23608ee.jpg";